import { call, put, takeLatest } from 'redux-saga/effects';
import { setToken } from './actions';
import { authLogin } from './api';
import { AUTH_LOGIN } from './constants';

function* asyncAuthLogin(param: any) {
  const token: string | null = yield call(authLogin, param.payload.auth);
  yield put(setToken(token));
}

export function* sagaWatcher() {
  yield takeLatest(AUTH_LOGIN, asyncAuthLogin);
}

const gens = [sagaWatcher()];
export default gens;
